import { graphql, useStaticQuery } from "gatsby";
import { CtaButton } from "./CtaButton";
import { useLocale } from "../../hooks/useLocale";
import { CtaSection } from "./CtaSection";
import { getSlugFromData } from "./getSlugFromData";

const useQuery = () => {
  const locale = useLocale();
  const dataLocales = useStaticQuery(graphql`
    query contactCtaQuery {
      global: datoCmsGlobal {
        cta: _allContactCtaLocales {
          locale
          value {
            ctaButton
            ctaUrl
            ctaDescription
            ctaTitle
          }
        }
      }
      slug: datoCmsContact {
        _allSlugLocales {
          locale
          value
        }
      }
    }
  `);

  const data = dataLocales.global.cta.find(
    (item: any) => item.locale === locale
  );

  return { ...data.value, slug: getSlugFromData(dataLocales) };
};

export const ContactCtaButton = (props: { className?: string }) => {
  const data = useQuery();
  return <CtaButton label={data.ctaButton} url={data.slug} {...props} />;
};

export const ContactCtaSection = () => {
  const data = useQuery();

  if (!data) {
    return null;
  }

  return (
    <CtaSection
      title={data.ctaTitle}
      label={data.ctaButton}
      linkTo={data.slug}
    />
  );
};
